// axios 配置
import axios from 'axios'
import GLOBAL from '../lib/global.vue'
//qs
import qs from 'qs'
//qs
import { Dialog } from 'vant';
import { Loading } from 'element-ui';
const $ajax = axios.create({
    // baseURL: GLOBAL.WEB_SITE,
    // timeout: 30000
})

// http request 拦截器
$ajax.interceptors.request.use(
    config => {
        // console.log(config.data);
        if (!config.data.token) {
            // config.data.token = localStorage.getItem('token')
        }
        config.data = qs.stringify(config.data)
        config.headers = {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
            // config.params = {
            //     'token': localStorage.getItem('token')
            // }

        return config
    },
    err => {
        return Promise.reject(err)
    }
)

// http respone 拦截器
$ajax.interceptors.response.use(
    response => {
        if (response.data.msg == '身份校验失败.') {
            // Dialog.alert({
            //     title: '温馨提示',
            //     message: response.data.msg,
            //     showConfirmButton: false,
            //     showCancelButton: false,
            // });
            localStorage.clear();
            location.href = GLOBAL.WEB_URL
            return;
        }
        return response
    },
    error => {
        return Promise.reject(error.response.data)
    }
)

/**
 * get 请求方法
 * @param url
 * @param data
 * @return {Promise}
 */
export function get(url, data = {}) {
    let token = localStorage.getItem('token')
    let params = {
        ...data,
        token
    }
    return new Promise((resolve, reject) => {
        $ajax.get(url, {
            param: params
        }).then(response => {
            resolve(response.data)
        }, err => {
            reject(err)
        })
    })
}

/**
 * post 请求方法
 * @param url
 * @param data
 * @return {Promise}
 */
export function post(url, data = {}) {
    let token = localStorage.getItem('token')
    let params = {
        ...data,
        token
    }
    Loading.service({
        background: 'rgba(255, 255, 255, 0.7)',
        text: '加载中...'
    })
    return new Promise((resolve, reject) => {
        $ajax.post(url, params).then(response => {
            let loadingInstance = Loading.service('body');
            this.$nextTick(() => {
                loadingInstance.close();
            });
            // console.group(url)
            // console.log('%c 请求路径--->', 'color: #1ba01b', url)
            // console.log('%c 请求参数--->', 'color: #1ba01b', data)
            // console.log('%c 成功--->', 'color: #1ba01b', response.data)
            // console.groupEnd()
            resolve(response.data)
        }, err => {
            // console.group(url)
            // console.error('%c 请求路径--->', url)
            // console.error('%c 请求参数--->', data)
            // console.error('%c 失败--->', err)
            // console.groupEnd()
            reject(err)
        })
    })
}